import { ChangeEvent, KeyboardEvent, ReactNode } from 'react';

import { Input } from '../Input/Input';
import { PHONE_NUMBER_MAX_LENGTH } from './constants/phoneNumberMaxLength';
import { formatValue } from './functions/formatValue';
import { isAllowedNumericKey } from './functions/isAllowedNumericKey';
import { NumberInputProps } from './types/NumberInputProps';

export const NumberInput = ({
  currency = false,
  dob = false,
  number = false,
  phone = false,
  ssn = false,
  ...props
}: NumberInputProps): ReactNode => {
  const { onChange, onKeyDown } = props;

  // `readonly string[]` is only meaningful for a multiple <select>
  const value = props.value as string | number | undefined;

  const masks = { currency, dob, number, phone, ssn };

  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    const formatted = formatValue(event.target.value, masks);

    // Only when it actually changed, so the caret is not reset on a keystroke
    // the formatter left alone.
    if (formatted !== event.target.value) {
      event.target.value = formatted;
    }

    if (onChange) {
      onChange(event);
    }
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>): void => {
    if (!isAllowedNumericKey(event)) {
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  return (
    <Input
      inputMode="numeric"
      type={phone ? 'tel' : 'text'}
      {...props}
      maxLength={phone ? PHONE_NUMBER_MAX_LENGTH : props.maxLength}
      value={value === undefined ? undefined : formatValue(value, masks)}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
    />
  );
};
